import React from 'react';

import '@app/scss/components/newsPreview.scss';

interface NewsPreviewProps {
	title: string;
	source: string | JSX.Element;
	url: string;
}

const NewsPreview: React.FC<NewsPreviewProps> = ({ title, source, url }) => (
	<a className="news-preview-wrapper" href={url} target="_blank" rel="noopener noreferrer">
		<section className="news-preview">
			<p className="news-preview__title">{title}</p>
			<p className="news-preview__source">{source}</p>
		</section>
	</a>
);

export default NewsPreview;
